export default "__VITE_ASSET__8baf7a69__"